<template>
    <MagFormRow :compact :highlighted :large-icon>
        <slot></slot>
        <template #icon>
            <slot name="icon"></slot>
        </template>
        <template #label>
            <slot name="label"></slot>
        </template>
        <template #caption>
            <slot name="caption"></slot>
        </template>
        <template #control="{ id, disabled }">
            <button class="_button" v-bind="$attrs" :id :disabled>
                <mg-icon icon="caret-right" />
            </button>
        </template>
    </MagFormRow>
</template>

<script setup lang="ts">
import MagFormRow from "@/components/layout/MagFormRow.vue";

defineProps<{
    highlighted?: boolean;
    disabled?: boolean;
    largeIcon?: boolean;
    compact?: 0 | 1 | 2;
}>();

defineSlots<{
    icon: () => any;
    label: () => any;
    default: () => any;
    caption: () => any;
}>();

defineOptions({
    inheritAttrs: false,
});
</script>
